import { translate, useLocale } from "../localization";
// ProtectedRoute.js
import React from "react";
import { hasAccountPermission } from "../utility/accountPermissions";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { normalizeRoleName } from "../utility/accountRoles";

const ProtectedRoute = ({
  requiredPermission,
  allowedRoles,
  redirectPathAuth = "/login",
  redirectPathPermission = "/unauthorized",
}) => {
  useLocale();
  const { isAuthenticated, isLoading, permissions, roleName, isAccountProfileLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div>{translate("Loading...")}</div>;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to={redirectPathAuth} state={{ from: location }} replace />
    );
  }

  if (allowedRoles && isAccountProfileLoading && !roleName) {
    return <div role="status">{translate("Loading account...")}</div>;
  }

  if (allowedRoles && !allowedRoles.includes(normalizeRoleName(roleName))) {
    return <Navigate to={redirectPathPermission} replace />;
  }

  // If a required permission is provided, check if the user has it.
  if (
    requiredPermission &&
    !hasAccountPermission(permissions, requiredPermission)
  ) {
    return <Navigate to={redirectPathPermission} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
